import countries from "../consts/countries.json";
import { Country } from "../models/Country";

export const removeUnwantedCharacters = ( value: string ): string => {
  const cleaned = value.replace(/[^\d]/g, '');
  return value.trim().startsWith('+') ? `+${ cleaned }` : cleaned;
};

const onlyDigits = ( value: string | null | undefined ) => ( value ?? "" ).replace(/\D/g, "" );

const countryCodeDigits = ( country: Country ) => onlyDigits( country.code );

const resolveCountryByPhone = ( phone: string ) => {
  const digits = onlyDigits( phone );

  return [ ...( countries as Array<Country> ) ]
    .sort(( a, b ) => countryCodeDigits( b ).length - countryCodeDigits( a ).length )
    .find(( country ) => digits.startsWith( countryCodeDigits( country )));
};

const maskLocalCapacity = ( mask: string ) => ( mask.match(/9/g) ?? [] ).length;

const resolvePhoneMask = ( country: Country, localDigits: string ) => {
  const masks = Array.isArray( country.mask ) ? country.mask : [ country.mask ];

  return masks.find(( mask ) => maskLocalCapacity( mask ) >= localDigits.length ) ?? masks[ masks.length - 1 ];
};

const applyPhoneMask = ( mask: string, localDigits: string ) => {
  let digitIndex = 0;
  let result = "";

  for( const char of mask ) {
    if( char !== "9" ) {
      if( digitIndex > 0 || localDigits.length > 0 ) result += char;
      continue;
    }

    if( digitIndex >= localDigits.length ) break;
    result += localDigits[ digitIndex ];
    digitIndex++;
  }

  if( digitIndex < localDigits.length ) result += localDigits.slice( digitIndex );

  return result.trim();
};

export const formatPhoneByDDI = ( phone: string | null | undefined ): string => {
  const digits = onlyDigits( phone );
  if( digits === "" ) return "";

  const country = resolveCountryByPhone( digits );
  if( !country ) return phone ?? "";

  const codeDigits = countryCodeDigits( country );
  const localDigits = digits.slice( codeDigits.length );
  const mask = resolvePhoneMask( country, localDigits );
  const formattedLocal = applyPhoneMask( mask, localDigits );

  return formattedLocal ? `${ country.code } ${ formattedLocal }` : country.code;
};
